import pickel from "../../../images/pickel2.jpg"
import cricket from '../../../images/cricket.jpg'
import padel from '../../../images/padel.jpg'
const sportsList= [
  {
    name: "Football",
    followers: "450 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/ef8829ae136f83675ff1bbe03940b8264440620d851065f33229ae38c48ba353?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Basketball",
    followers: "350 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/821e88d847b5201d52e7c0147fe292e7bb3edab3f3b889c4a68ec487c836455c?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Cricket",
    followers: "45 million",
    imageUrl: cricket
  },
  {
    name: "Pickle ball ",
    followers: "250 million",
    imageUrl: pickel
  },
  {
    name: "Tennis",
    followers: "18.9 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/9abb589a030cef6af84475117ec4ab90a3d997fc4692235450be1d3ff29f0237?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Padel",
    followers: "12 million",
    imageUrl: padel
  },
  {
    name: "Volleyball",
    followers: "950 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/00e1c9d0e12444ab9a8664a287cebb830f02836dbc0a68c5f45a7b813fa47633?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Badminton",
    followers: "75 million",
    imageUrl: "https://superblog.supercdn.cloud/site_cuid_clr6oh1no0006rmr89yhkxgu8/images/badminton-14280461280-1721457562607-compressed.jpg"
  },
  {
    name: "Hockey",
    followers: "4 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/b7bd1e16aaf1e0c06cb139593dd97d276862f61e6bed561843e0a9a8e61df78c?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Rugby",
    followers: "40 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/494414945bd1999a8149e0c66ef2cb5a6dabe2079d523361c4a70cdbe5720ff2?apiKey=f523408d85c94fc8913d645c993f4c42&"
  },
  {
    name: "Baseball",
    followers: "65 million",
    imageUrl: "https://cdn.builder.io/api/v1/image/assets/621a9be51e55481592185121250bd32e/c6fa231caad3e759a1a41090429dd18745e6ea11a675d124229c40462c9da09b?apiKey=f523408d85c94fc8913d645c993f4c42&"
  }
];
export default sportsList;